import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import styles from "./top-nav.module.css";
import { FaUserCircle, FaChevronDown, FaBell } from "react-icons/fa";
import api from "../../../services/axiosConfig";
import { useSelector } from "react-redux";
import { FaClock, FaUser, FaKey, FaPhone, FaSignOutAlt } from "react-icons/fa";


const TopNav = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);
  const dropdownRef = useRef();
  const notifRef = useRef();
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
      if (notifRef.current && !notifRef.current.contains(e.target)) {
        setNotifOpen(false);
      }
    };

    const handleEscape = (e) => {
      if (e.key === "Escape") {
        setDropdownOpen(false);
        setNotifOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  const handleDropdownItemClick = () => {
    setDropdownOpen(false);
  };

  const handleLogOutDropdownItemClick = () => {
    logout();
    setDropdownOpen(false);
  };

  async function logout() {
    api.post("/api/users/logout", {}, { withCredentials: true });
  }

  const handleContactDropdownItemClick = () => {
    setDropdownOpen(false);
  };

  const notifCount = 3; // تعداد اعلان فرضی

  function getRemainingDays(expireDate) {
    if (!expireDate) return 0;
    const expire = new Date(expireDate);
    const today = new Date();
    const diffTime = expire - today;
    return Math.max(0, Math.ceil(diffTime / (1000 * 60 * 60 * 24))); // اختلاف بر حسب روز
  }
  

  return (
    <header className={styles.topnav}>
      <div className={styles.container}>
        <Link to="/" className={styles.brand}>
          اتو یاد<h6>ثبت و یادآوری سرویس</h6>
        </Link>

        {!user && (
          <nav className={styles.navLinks}>
            <Link to="/login" className={styles.navLink}>ورود</Link>
            <Link to="/register" className={styles.navLink}>ثبت‌نام</Link>
          </nav>
        )}

        {user && (
          <div className={styles.userArea}>
            {/* منوی زنگوله */}
            {/* <div className={styles.notificationWrapper} ref={notifRef}>
              <button
                className={styles.notifButton}
                onClick={() => setNotifOpen(!notifOpen)}
                aria-expanded={notifOpen}
                aria-label="اعلان‌ها"
              >
                <FaBell size={20} />
                {notifCount > 0 && (
                  <span className={styles.notifBadge}>{notifCount}</span>
                )}
              </button>

              <ul
                className={`${styles.notifDropdown} ${notifOpen ? styles.show : ""}`}
              >
                <li className={styles.notifItem}>اعلان ۱</li>
                <li className={styles.notifItem}>اعلان ۲</li>
                <li className={styles.notifItem}>اعلان ۳</li>
                <li className={styles.notifEmpty}>تمام اعلان‌ها خوانده شده‌اند</li>
              </ul>
            </div> */}

            {/* منوی کاربر */}
            <div className={styles.userDropdown} ref={dropdownRef}>
              <button
                className={styles.userButton}
                onClick={() => setDropdownOpen(!dropdownOpen)}
                aria-expanded={dropdownOpen}
              >
                {user?.imageUrl && !user.imageUrl?.includes("/Images/Profile/profile.jpg") ? (
                  <img
                    src={user.imageUrl}
                    alt="avatar"
                    className={styles.avatar}
                  />
                ) : (
                  <FaUserCircle size={32} />
                )}
                <span>{user.fullName}</span>
                <FaChevronDown className={styles.arrow} />
              </button>

              <ul
                className={`${styles.dropdownMenu} ${dropdownOpen ? styles.show : ""}`}
              >
                <li>
                  <Link to="/subscription" onClick={handleDropdownItemClick} className={styles.dropdownItem}>
                      <FaClock className={`${styles.icon} ${styles.iconClock}`} />
                      {getRemainingDays(user.expireDate) === 0
                      ? "اشتراک شما به پایان رسیده"
                      : `${getRemainingDays(user.expireDate)} روز از اشتراک باقی مانده`}  
                  </Link>
                </li>
                <li>
                  <Link to="/account" onClick={handleDropdownItemClick} className={styles.dropdownItem}>
                    <FaUser className={`${styles.icon} ${styles.iconUser}`} />
                    پروفایل
                  </Link>
                </li>
                {/* <li>
                  <Link to="/settings" onClick={handleDropdownItemClick} className={styles.dropdownItem}>تنظیمات</Link>
                </li> */}
                <li>
                  <Link to="/change-pass" onClick={handleDropdownItemClick} className={styles.dropdownItem}>
                    <FaKey className={`${styles.icon} ${styles.iconKey}`} />
                    تغییر رمز عبور
                  </Link>
                </li>
                {/* برای خروج زدن باید رفرش توکن فعال گردد و زمان انقضای توکن اصلی کم گردد */}
                {/* <li> */}
                  <hr className={styles.divider} />
                {/* </li> */}
                <li>
                  <Link to="/contact" onClick={handleContactDropdownItemClick} className={styles.dropdownItem}>
                    <FaPhone className={`${styles.icon} ${styles.iconPhone}`} />
                    تماس با ما
                  </Link>
                </li>
                {/* <li>
                  <Link to="/login" onClick={handleLogOutDropdownItemClick} className={styles.dropdownItem}>
                    <FaSignOutAlt className={`${styles.icon} ${styles.iconLogout}`} />
                    خروج
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default TopNav;
